export const csvToFile = (csvData: any, filename = 'data') => {
  // Create a Blob from the JSON string
  const blob = new Blob([csvData], { type: 'text/csv' });

  // Create a file from the Blob (optional)
  const file = new File([blob], `${filename}.csv`, { type: 'text/csv' });

  return file;
};
